export default "__VITE_ASSET__5g$AXzmg__";